import { throttled, updateMenu, elementsOverlap } from './utilities';

const servicesWrapper = document.querySelector('[data-ref="services"]');
if (servicesWrapper) {
	let menu = servicesWrapper.querySelector('[data-ref="services-content-menu"]'),
		sections = servicesWrapper.querySelectorAll('[data-ref="services-content-item"]');

	window.addEventListener('scroll', throttled(150, () => { updateMenu(menu, sections, true) } ));
}

const caseContentWrapper = document.querySelector('[data-ref="case-content"]');
if (caseContentWrapper) {
	let sections = caseContentWrapper.querySelectorAll('[data-ref="case-content-item"]'),
		menu = caseContentWrapper.querySelector('[data-ref="case-content-menu"]');

	window.addEventListener('scroll', () => updateMenu(menu, sections));
}